import { buildProps, definePropType } from '../../../utils/vue/props/runtime.mjs';

const visualHiddenProps = buildProps({
  style: {
    type: definePropType([String, Object, Array]),
    default: () => ({})
  }
});

export { visualHiddenProps };
//# sourceMappingURL=visual-hidden.mjs.map
